export const SIGN_OUT = 'SIGN_OUT';

export const signOut = history => ({
    type: SIGN_OUT,
    payload: { history }
});